module.exports = __webpack_public_path__ + "img/icon-add-white.5987b1b2.svg";